import { ChannelTypeEnum, SmsProviderIdEnum } from '../../../types';
import { UTM_CAMPAIGN_QUERY_PARAM } from '../../../ui';
import { africasTalkingConfig, afroSmsConfig, azureSmsConfig, bandwidthConfig, brevoSmsConfig, bulkSmsConfig, burstSmsConfig, clickatellConfig, clickSendConfig, cmTelecomConfig, eazySmsConfig, firetextConfig, fortySixElksConfig, genericSmsConfig, gupshupConfig, ISendProProviderConfig, iMediaConfig, infobipSMSConfig, iSendSmsConfig, kannelConfig, maqsamConfig, messagebirdConfig, mobishastraConfig, nexmoConfig, plivoConfig, ringCentralConfig, sendchampConfig, simpleTextingConfig, sinchConfig, sms77Config, smsCentralConfig, smsmodeProviderConfig, snsConfig, telnyxConfig, termiiConfig, twilioConfig, unifonicConfig, } from '../credentials';
export const smsProviders = [
    {
        id: SmsProviderIdEnum.Novu,
        displayName: 'Novu SMS',
        channel: ChannelTypeEnum.SMS,
        credentials: [],
        docReference: `https://docs.novu.co/integrations/providers/default-providers${UTM_CAMPAIGN_QUERY_PARAM}#novu-sms-provider`,
        logoFileName: { light: 'novu.png', dark: 'novu.png' },
    },
    {
        id: SmsProviderIdEnum.Nexmo,
        displayName: 'Nexmo',
        channel: ChannelTypeEnum.SMS,
        credentials: nexmoConfig,
        docReference: `https://docs.novu.co/integrations/providers/sms/nexmo${UTM_CAMPAIGN_QUERY_PARAM}`,
        logoFileName: { light: 'nexmo.png', dark: 'nexmo.png' },
    },
    {
        id: SmsProviderIdEnum.Plivo,
        displayName: 'Plivo',
        channel: ChannelTypeEnum.SMS,
        credentials: plivoConfig,
        docReference: `https://docs.novu.co/integrations/providers/sms/plivo${UTM_CAMPAIGN_QUERY_PARAM}`,
        logoFileName: { light: 'plivo.png', dark: 'plivo.png' },
    },
    {
        id: SmsProviderIdEnum.Sms77,
        displayName: 'sms77',
        channel: ChannelTypeEnum.SMS,
        credentials: sms77Config,
        docReference: `https://docs.novu.co/integrations/providers/sms/sms77${UTM_CAMPAIGN_QUERY_PARAM}`,
        logoFileName: { light: 'sms77.svg', dark: 'sms77.svg' },
    },
    {
        id: SmsProviderIdEnum.SNS,
        displayName: 'SNS',
        channel: ChannelTypeEnum.SMS,
        credentials: snsConfig,
        docReference: `https://docs.novu.co/integrations/providers/sms/aws-sns${UTM_CAMPAIGN_QUERY_PARAM}`,
        logoFileName: { light: 'sns.svg', dark: 'sns.svg' },
    },
    {
        id: SmsProviderIdEnum.Telnyx,
        displayName: 'Telnyx',
        channel: ChannelTypeEnum.SMS,
        credentials: telnyxConfig,
        docReference: `https://docs.novu.co/integrations/providers/sms/telnyx${UTM_CAMPAIGN_QUERY_PARAM}`,
        logoFileName: { light: 'telnyx.png', dark: 'telnyx.png' },
    },
    {
        id: SmsProviderIdEnum.MessageBird,
        displayName: 'MessageBird',
        channel: ChannelTypeEnum.SMS,
        credentials: messagebirdConfig,
        docReference: `https://docs.novu.co/integrations/providers/sms/messagebird${UTM_CAMPAIGN_QUERY_PARAM}`,
        logoFileName: { light: 'messagebird.png', dark: 'messagebird.png' },
    },
    {
        id: SmsProviderIdEnum.Twilio,
        displayName: 'Twilio',
        channel: ChannelTypeEnum.SMS,
        credentials: twilioConfig,
        docReference: `https://docs.novu.co/integrations/providers/sms/twilio${UTM_CAMPAIGN_QUERY_PARAM}`,
        logoFileName: { light: 'twilio.png', dark: 'twilio.png' },
    },
    {
        id: SmsProviderIdEnum.Gupshup,
        displayName: 'Gupshup',
        channel: ChannelTypeEnum.SMS,
        credentials: gupshupConfig,
        docReference: 'https://docs.gupshup.io/docs/send-single-message',
        logoFileName: { light: 'gupshup.png', dark: 'gupshup.png' },
    },
    {
        id: SmsProviderIdEnum.Firetext,
        displayName: 'Firetext',
        channel: ChannelTypeEnum.SMS,
        credentials: firetextConfig,
        docReference: 'https://www.firetext.co.uk/docs',
        logoFileName: { light: 'firetext.svg', dark: 'firetext.svg' },
    },
    {
        id: SmsProviderIdEnum.Infobip,
        displayName: 'Infobip',
        channel: ChannelTypeEnum.SMS,
        credentials: infobipSMSConfig,
        docReference: `https://docs.novu.co/integrations/providers/sms/infobip${UTM_CAMPAIGN_QUERY_PARAM}`,
        logoFileName: { light: 'infobip.png', dark: 'infobip.png' },
    },
    {
        id: SmsProviderIdEnum.BurstSms,
        displayName: 'Kudosity (formerly BurstSMS)',
        channel: ChannelTypeEnum.SMS,
        credentials: burstSmsConfig,
        docReference: 'https://docs.novu.co/platform/integrations/sms/kudosity',
        logoFileName: { light: 'burst-sms.svg', dark: 'burst-sms.svg' },
    },
    {
        id: SmsProviderIdEnum.BulkSms,
        displayName: 'BulkSMS',
        channel: ChannelTypeEnum.SMS,
        credentials: bulkSmsConfig,
        docReference: 'https://www.bulksms.com/developer/json/v1/',
        logoFileName: { light: 'bulk-sms.png', dark: 'bulk-sms.png' },
    },
    {
        id: SmsProviderIdEnum.ISendSms,
        displayName: 'iSend SMS',
        channel: ChannelTypeEnum.SMS,
        credentials: iSendSmsConfig,
        docReference: 'https://send.com.ly/developers/docs',
        logoFileName: { light: 'isend-sms.svg', dark: 'isend-sms.svg' },
    },
    {
        id: SmsProviderIdEnum.Clickatell,
        displayName: 'clickatell',
        channel: ChannelTypeEnum.SMS,
        credentials: clickatellConfig,
        betaVersion: true,
        docReference: `https://docs.novu.co/integrations/providers/sms/clickatell${UTM_CAMPAIGN_QUERY_PARAM}`,
        logoFileName: { light: 'clickatell.png', dark: 'clickatell.png' },
    },
    {
        id: SmsProviderIdEnum.FortySixElks,
        displayName: '46elks',
        channel: ChannelTypeEnum.SMS,
        credentials: fortySixElksConfig,
        docReference: 'https://46elks.com/docs/send-sms',
        logoFileName: { light: '46elks.png', dark: '46elks.png' },
    },
    {
        id: SmsProviderIdEnum.Kannel,
        displayName: 'Kannel SMS',
        channel: ChannelTypeEnum.SMS,
        credentials: kannelConfig,
        betaVersion: true,
        docReference: 'https://www.kannel.org/doc.shtml',
        logoFileName: { light: 'kannel.png', dark: 'kannel.png' },
    },
    {
        id: SmsProviderIdEnum.Maqsam,
        displayName: 'Maqsam',
        channel: ChannelTypeEnum.SMS,
        credentials: maqsamConfig,
        docReference: 'https://portal.maqsam.com/docs/v2/sms',
        logoFileName: { light: 'maqsam.png', dark: 'maqsam.png' },
    },
    {
        id: SmsProviderIdEnum.SmsCentral,
        displayName: 'SMS Central',
        channel: ChannelTypeEnum.SMS,
        credentials: smsCentralConfig,
        docReference: 'https://www.smscentral.com.au/sms-api/',
        logoFileName: { light: 'sms-central.png', dark: 'sms-central.png' },
    },
    {
        id: SmsProviderIdEnum.Termii,
        displayName: 'Termii',
        channel: ChannelTypeEnum.SMS,
        credentials: termiiConfig,
        docReference: `https://docs.novu.co/integrations/providers/sms/termii${UTM_CAMPAIGN_QUERY_PARAM}`,
        logoFileName: { light: 'termii.png', dark: 'termii.png' },
    },
    {
        id: SmsProviderIdEnum.AfricasTalking,
        displayName: `Africa's Talking`,
        channel: ChannelTypeEnum.SMS,
        credentials: africasTalkingConfig,
        docReference: `https://docs.novu.co/integrations/providers/sms/africas-talking${UTM_CAMPAIGN_QUERY_PARAM}`,
        logoFileName: { light: 'africas-talking.svg', dark: 'africas-talking.svg' },
    },
    {
        id: SmsProviderIdEnum.Sendchamp,
        displayName: `Sendchamp`,
        channel: ChannelTypeEnum.SMS,
        credentials: sendchampConfig,
        docReference: `https://docs.novu.co/integrations/providers/sms/sendchamp${UTM_CAMPAIGN_QUERY_PARAM}`,
        logoFileName: { light: 'sendchamp.svg', dark: 'sendchamp.svg' },
    },
    {
        id: SmsProviderIdEnum.GenericSms,
        displayName: `SMS Webhook`,
        channel: ChannelTypeEnum.SMS,
        credentials: genericSmsConfig,
        docReference: `https://docs.novu.co/platform/integrations/sms/sms-webhook${UTM_CAMPAIGN_QUERY_PARAM}`,
        logoFileName: { light: 'generic-sms.svg', dark: 'generic-sms.svg' },
    },
    {
        id: SmsProviderIdEnum.Clicksend,
        displayName: `Clicksend`,
        channel: ChannelTypeEnum.SMS,
        credentials: clickSendConfig,
        docReference: 'https://developers.clicksend.com/docs/rest/v3/?javascript--nodejs#send-sms',
        logoFileName: { light: 'clicksend.png', dark: 'clicksend.png' },
    },
    {
        id: SmsProviderIdEnum.Simpletexting,
        displayName: `SimpleTexting`,
        channel: ChannelTypeEnum.SMS,
        credentials: simpleTextingConfig,
        docReference: `https://docs.novu.co/channels/sms/simpletexting${UTM_CAMPAIGN_QUERY_PARAM}`,
        logoFileName: { light: 'simpletexting.png', dark: 'simpletexting.png' },
    },
    {
        id: SmsProviderIdEnum.Bandwidth,
        displayName: `Bandwidth`,
        channel: ChannelTypeEnum.SMS,
        credentials: bandwidthConfig,
        betaVersion: true,
        docReference: `https://dev.bandwidth.com/docs/messaging/createMessage${UTM_CAMPAIGN_QUERY_PARAM}`,
        logoFileName: { light: 'bandwidth.png', dark: 'bandwidth.png' },
    },
    {
        id: SmsProviderIdEnum.AzureSms,
        displayName: `Azure Sms`,
        channel: ChannelTypeEnum.SMS,
        credentials: azureSmsConfig,
        docReference: `https://docs.novu.co/channels/sms/azure${UTM_CAMPAIGN_QUERY_PARAM}`,
        logoFileName: { light: 'azure-sms.png', dark: 'azure-sms.png' },
    },
    {
        id: SmsProviderIdEnum.RingCentral,
        displayName: `RingCentral`,
        channel: ChannelTypeEnum.SMS,
        credentials: ringCentralConfig,
        docReference: 'https://developers.ringcentral.com/guide/messaging',
        logoFileName: { light: 'ring-central.svg', dark: 'ring-central.svg' },
    },
    {
        id: SmsProviderIdEnum.BrevoSms,
        displayName: `Brevo`,
        channel: ChannelTypeEnum.SMS,
        credentials: brevoSmsConfig,
        docReference: 'https://developers.brevo.com/reference/sendtransacsms',
        logoFileName: { light: 'brevo.svg', dark: 'brevo.svg' },
    },
    {
        id: SmsProviderIdEnum.EazySms,
        displayName: `Eazy`,
        channel: ChannelTypeEnum.SMS,
        credentials: eazySmsConfig,
        docReference: 'https://developers.eazy.im/#678805af-be7b-4487-93a4-c1007b7920f5',
        logoFileName: { light: 'eazy-sms.svg', dark: 'eazy-sms.svg' },
    },
    {
        id: SmsProviderIdEnum.Mobishastra,
        displayName: 'Mobishastra',
        channel: ChannelTypeEnum.SMS,
        credentials: mobishastraConfig,
        docReference: 'https://telkosh.com/mobishastra/',
        logoFileName: { light: 'mobishastra.png', dark: 'mobishastra.png' },
    },
    {
        id: SmsProviderIdEnum.Sinch,
        displayName: 'Sinch',
        channel: ChannelTypeEnum.SMS,
        credentials: sinchConfig,
        docReference: `https://docs.novu.co/integrations/providers/sms/sinch${UTM_CAMPAIGN_QUERY_PARAM}`,
        logoFileName: { light: 'sinch.png', dark: 'sinch.png' },
    },
    {
        id: SmsProviderIdEnum.AfroSms,
        displayName: 'Afro Message',
        channel: ChannelTypeEnum.SMS,
        credentials: afroSmsConfig,
        docReference: 'https://afromessage.com/developers',
        logoFileName: { light: 'afro-sms.png', dark: 'afro-sms.png' },
    },
    {
        id: SmsProviderIdEnum.Unifonic,
        displayName: 'Unifonic',
        channel: ChannelTypeEnum.SMS,
        credentials: unifonicConfig,
        docReference: 'https://docs.unifonic.com/articles/#!products-documentation/getting-started-with-unifonic',
        logoFileName: { light: 'unifonic.svg', dark: 'unifonic.svg' },
    },
    {
        id: SmsProviderIdEnum.Smsmode,
        displayName: 'smsmode',
        channel: ChannelTypeEnum.SMS,
        credentials: smsmodeProviderConfig,
        docReference: 'https://dev.smsmode.com/sms/v1/#tag/Message/operation/send-message',
        logoFileName: { light: 'smsmode.svg', dark: 'smsmode.svg' },
    },
    {
        id: SmsProviderIdEnum.IMedia,
        displayName: 'iMedia',
        channel: ChannelTypeEnum.SMS,
        credentials: iMediaConfig,
        docReference: '',
        logoFileName: { light: 'imedia.png', dark: 'imedia.png' },
    },
    {
        id: SmsProviderIdEnum.ISendProSms,
        displayName: 'iSendPro',
        channel: ChannelTypeEnum.SMS,
        credentials: ISendProProviderConfig,
        docReference: 'https://www.isendpro.com/sms-api.php',
        logoFileName: { light: 'isendpro.svg', dark: 'isendpro.svg' },
    },
    {
        id: SmsProviderIdEnum.CmTelecom,
        displayName: 'CM.com',
        channel: ChannelTypeEnum.SMS,
        credentials: cmTelecomConfig,
        docReference: 'https://developers.cm.com/messaging/docs/sms',
        logoFileName: { light: 'cm-telecom.svg', dark: 'cm-telecom.svg' },
    },
];
//# sourceMappingURL=sms.js.map